/**
 * 定期購入申込用商品
 */
import { ApiClient } from '@/services/api/client'

interface RawSubscriptionApplyingItem {
  readonly item: {
    readonly sku_id: string
    readonly root_id: string
  }
  readonly cancel: {
    readonly enable_range: {
      readonly begin: string
      readonly end: string
    }
  }
  readonly config: {
    readonly finite: boolean
    readonly enable_range: {
      readonly label: string
    }
  }
}

export interface SubscriptionApplyingItemResponse {
  readonly item: {
    readonly sku_id: string
    readonly root_id: string
  }
  readonly cancel: {
    readonly enable_range: {
      readonly begin: Date
      readonly end: Date
    }
  }
  readonly config: {
    readonly finite: boolean
    readonly enable_range: {
      readonly label: string
    }
  }
}

export class SubscriptionApplyingItemService {
  static get forHost(): SubscriptionApplyingItemService {
    return new SubscriptionApplyingItemService(null)
  }

  private constructor(private readonly brandEnglishName: string | null) {}

  async findBySkuId(skuId: string): Promise<SubscriptionApplyingItemResponse> {
    const paths = [
      '/api', 'common', this.brandEnglishName, 'subscription', 'applying_item', 'sku', skuId,
    ].filter(p => p !== null)

    const res = await ApiClient.get(paths.join('/'))
    const data: RawSubscriptionApplyingItem = res.body.data

    return {
      ...data,
      cancel: {
        enable_range: {
          begin: new Date(data.cancel.enable_range.begin),
          end: new Date(data.cancel.enable_range.end),
        },
      },
    }
  }
}
